module.exports = __webpack_public_path__ + "img/wallet.376f3f55.svg";